import React, { useEffect, useState, useCallback, useContext } from 'react';

import { SelectContext } from './SelectContext';
import { IDominioSelect } from '../../../modules/types/Dominio';
import { getDominiosSelect } from '../../../services/dominio/dominioService';
import { AuthContext } from '../Auth/AuthContext';

interface Props {
  children: React.ReactNode;
}

export const SelectProvider: React.FC<Props> = ({ children }) => {
  const authContext = useContext(AuthContext);

  const user = authContext?.user ?? null;

  const [dominiosSelect, setDominiosSelect] = useState<IDominioSelect[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const carregarDominiosSelect = useCallback(async () => {
    try {
      setLoading(true);

      const dados = await getDominiosSelect();
      setDominiosSelect(dados);

      localStorage.setItem('dominios_select', JSON.stringify(dados));
    } catch (error) {
      console.error('Erro ao carregar domínios para selects:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) {
      localStorage.removeItem('dominios_select');
      carregarDominiosSelect();
    } else {
      // Logout
      setDominiosSelect([]);
      setLoading(false);
    }
  }, [user, carregarDominiosSelect]);

  /**
   * Fallback: reload de página com usuário já autenticado
   */
  useEffect(() => {
    if (!user) return;

    const cache = localStorage.getItem('dominios_select');
    if (cache) {
      setDominiosSelect(JSON.parse(cache));
      setLoading(false);
    }
  }, [user]);

  return (
    <SelectContext.Provider
      value={{
        dominiosSelect,
        carregarDominiosSelect,
        loading,
      }}
    >
      {children}
    </SelectContext.Provider>
  );
};
